import { render, staticRenderFns } from "./NoSearchResults.vue?vue&type=template&id=6bc9120e"
import script from "./NoSearchResults.vue?vue&type=script&lang=js"
export * from "./NoSearchResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports